export function formatBC(n) {
  const v = Number(n || 0);
  return v.toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatPeso(n) {
  return `₱${formatBC(n)}`;
}

export function shortRef(ref = "") {
  return ref.length > 12 ? `${ref.slice(0, 6)}…${ref.slice(-4)}` : ref;
}

export function countdownParts(seconds) {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (x) => String(x).padStart(2, "0");
  return { h: pad(h), m: pad(m), s: pad(sec), total: s };
}
